import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Modal, Icon } from 'antd'
import React from 'react'
import { store } from './utilities'
import { setField, modified as modifiedAction } from './action_creators'
import save from './save/save'

// Blocks navigation when `when` is true, showing a custom Save & Publish prompt.
// Returning `false` from history.block prevents navigation and skips the native
// window.confirm dialog (history v4 behavior), so we own the entire UX.
export function useNavigationBlocker(when) {
  const history = useHistory()

  useEffect(() => {
    if (!when) return

    const unblock = history.block((location, action) => {
      const proceed = () => {
        unblock()
        // history.replace works with a Location object directly and is not
        // overridden by the prefix wrapper in src/history.js (only push is).
        // For POP (browser back), replace to the target location is the safest
        // retry because go(-1) is unreliable after the block entry is removed.
        history.replace(location)
      }

      let modal
      modal = Modal.confirm({
        title: (
          <React.Fragment>
            Form is not published
            <Icon
              type="close"
              onClick={() => modal && modal.destroy()}
              style={{ position: 'absolute', top: 16, right: 16, cursor: 'pointer', color: 'rgba(0,0,0,0.45)', fontSize: 14 }}
            />
          </React.Fragment>
        ),
        content: 'This form has unpublished changes. Save and Publish before leaving?',
        okText: 'Save and Publish',
        cancelText: 'Leave without saving',
        onOk: async () => {
          try {
            store.dispatch(setField('form_field')('active', true))
            await save()
            store.dispatch(modifiedAction(false))
            proceed()
          } catch (e) {
            Modal.error({
              title: 'Save failed',
              content: 'Could not save the form. Please try again.',
            })
          }
        },
        onCancel: proceed,
      })

      return false
    })

    return unblock
  }, [when, history])
}
